import React from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';
import { CustomerEffortScore, FormError } from '@hvcgroep/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';
import { Helmet } from 'react-helmet';
import { Container } from '../../components';
import { setVote } from '../../actions/Entity/Vote';
import { APP_OPTIONS } from '../../config/constants';

const ApplicationSentScreen: React.FC = () => {
  const { t } = useTranslation();
  const voteStatus = useSelector((state: Immutable.Map<string, string>) => state.getIn(['uiInternal', 'vote', 'operations', 'set', 'status']));
  const dispatch = useDispatch();

  const onCustomerEffortScoreSelect = (score: number) => {
    // @ts-expect-error
    dispatch(setVote(score, 'block_content', APP_OPTIONS.parameters.cesTargetNid));
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container
        small
        className="u-margin--top-bottom--8"
        style={{
          whiteSpace: 'pre-wrap',
        }}
        fluid={false}
        large={false}
      >
        <h1>{t('application_sent.title')}</h1>

        <p>{t('application_sent.content')}</p>

        <h2>{t('application_sent.customer_effort_score_label')}</h2>

        {(
          voteStatus === UI_OPERATION_STATUS_ERROR ||
        voteStatus === UI_OPERATION_STATUS_REQUEST ||
        voteStatus === null
        ) && (
        <CustomerEffortScore onSelect={onCustomerEffortScoreSelect} />
        )}

        {voteStatus === UI_OPERATION_STATUS_SUCCESS && (
        <p className="text-bold">{t('application_sent.customer_effort_score_success')}</p>
        )}

        {voteStatus === UI_OPERATION_STATUS_ERROR && (
        <>
          {/* @ts-expect-error */}
          <FormError>
            {t('application_sent.customer_effort_score_error')}
          </FormError>
        </>
        )}
      </Container>
    </>
  );
};

export default ApplicationSentScreen;
